import axios from "axios";
axios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("token_admin");

const state = {
    profesionCategories: [],
    ubigeos: []
};

const getters = {
    profesionCategories: state => state.profesionCategories,
    ubigeos: state => state.ubigeos
};

const mutations = {
    setProfesionCategories(state, data) {
        const datosTransformados = data.map(({ categoria, elementos }) => ({
            stateAccordion: false,
            categoria,
            datos: elementos.map(({ ocupacion, id }) => ({
                nombre: ocupacion,
                id,
            })),
        }));
        state.profesionCategories = datosTransformados;
    },
    setUbigeosAgrupados(state, data) {
        state.ubigeos = data;
    }
};

const actions = {
    async getProfesionCategories({ commit }, payload) {
        return await axios
            .get(
                `${process.env.VUE_APP_HOST}/api/dashboard/profesion-categorias`
            )
            .then(({ data }) => {
                commit("setProfesionCategories", data);
                return data;
            })
            .catch((e) => {
                console.log(e);
            });
    },
    async getUbigeosAgrupados({ commit }, payload) {
        return await axios
            .get(
                `${process.env.VUE_APP_HOST}/api/dashboard/ubigeos/ubigeos-agrupados`
            )
            .then(({ data }) => {
                commit("setUbigeosAgrupados", data);
                return data;
            })
            .catch((e) => {
                console.log(e);
            });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
